/**
 * List component types
 * Configuration interfaces for the subscription list feature.
 * API response types are in services/types.ts.
 */

import { z } from "zod";
import { FilterOptionSchema, type FilterOption } from "@/pages/subscriptions/services/types";
import { SubscriptionType, SubscriptionStatus } from "@/pages/subscriptions/constants";

// Subscription columns configuration
export interface SubscriptionColumnsConfig {
  categoryOptions: FilterOption[];
  createdByOptions: FilterOption[];
  destinationOptions: FilterOption[];
  onToggleStatus: (id: number, currentStatus: SubscriptionStatus) => void;
  onDelete: (id: number) => void;
  onClone: (id: number) => void;
}

// ============================================================================
// Subscription Filters Response Types
// ============================================================================

export const SubscriptionFiltersResponseSchema = z.object({
  categories: z.array(FilterOptionSchema),
  subscription_types: z.array(FilterOptionSchema),
  created_by: z.array(FilterOptionSchema),
  destinations: z.array(FilterOptionSchema),
});

export type SubscriptionFiltersResponse = z.infer<typeof SubscriptionFiltersResponseSchema>;

// Filter parameters for subscription list API
export interface SubscriptionListFilters {
  page?: number;
  size?: number;
  rule_type?: SubscriptionType;
  category?: string;
  platform?: string;
  status?: SubscriptionStatus;
  search?: string;
  start_date?: string;
  end_date?: string;
  sort_by?: string;
  sort_order?: string;
}

// Filter parameters for subscription summary API
export interface SubscriptionSummaryFilters {
  rule_type?: SubscriptionType;
  category?: string;
  search?: string;
  start_date?: string;
  end_date?: string;
}
